import PropTypes from 'prop-types'

import { getCompanyName } from 'utils/company'
import SignedOutForm, {
  SignedOutFormContainer,
  UpperBackText
} from 'components/authentication/SignedOutForm'
import theme from 'theme'
import { sortBy } from 'utils/list'

export default function CompanyListForm({
  companies,
  handleCompanySelection,
  handleBack,
  submitting
}) {
  const sortedCompanies = sortBy(companies, company => getCompanyName(company))
  return (
    <SignedOutFormContainer>
      <UpperBackText onClick={handleBack}>Back to login</UpperBackText>
      <SignedOutForm title="Select company">
        {sortedCompanies.map((company, index) => (
          <Company
            key={company.name}
            company={company}
            handleCompanySelection={handleCompanySelection}
            index={index}
            submitting={submitting}
            total={companies.length}
          />
        ))}
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}

function Company({
  company,
  handleCompanySelection,
  index,
  total,
  submitting
}) {
  return (
    <div
      css={{
        textAlign: 'left',
        marginLeft: -theme.space[7],
        marginRight: -theme.space[7],
        paddingLeft: theme.space[7],
        paddingRight: theme.space[7],
        cursor: 'pointer',
        transition: '150ms background-color',
        '&:hover': {
          backgroundColor: theme.colors.grayOverlay[0]
        }
      }}
      data-test-company-list-company={company.name}
      onClick={() => {
        if (submitting) return
        handleCompanySelection(company.name)
      }}
    >
      <div
        css={{
          ...(index < total - 1 && {
            borderBottom: theme.border.base
          }),
          paddingTop: theme.space[3],
          paddingBottom: theme.space[3]
        }}
      >
        {getCompanyName(company)}
      </div>
    </div>
  )
}

Company.propTypes = {
  company: PropTypes.object.isRequired,
  handleCompanySelection: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  submitting: PropTypes.bool.isRequired
}

CompanyListForm.propTypes = {
  companies: PropTypes.array.isRequired,
  handleCompanySelection: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired
}
